<template>
  <div>
    <div class="alert-content">
      <div class="alert-message">{{ message }}</div>
      <slot />
    </div>
    <div class="alert-action" v-if="showBtns">
      <div v-if="['right', 'center'].includes(btnSide)" class="spacer"></div>
      <app-btn
        @click="action"
        color="yellow-grad"
        border="bottom"
        class="px-5"
        >{{ btnText }}</app-btn
      >
      <div v-if="['left', 'center'].includes(btnSide)" class="spacer"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    timeout: {
      type: [Number, String],
      default: 0
    },
    message: {
      type: String,
      required: true
    },
    showBtns: Boolean,
    btnText: {
      type: String,
      default: "OK"
    },
    btnSide: {
      type: String,
      default: "right"
    },
    btnAction: {
      type: Function,
      default: () => null
    }
  },

  mounted() {
    this.startTimeout();
  },

  methods: {
    startTimeout() {
      const delay = parseInt(this.timeout, 0);
      if (!delay) return;

      this.closeTimeout = setTimeout(() => {
        this.$modals.close();
      }, delay);
    },

    action() {
      if (this.btnAction) {
        this.btnAction();
      }

      this.$modals.close();
    }
  }
};
</script>

<style lang="scss">
.alert-content {
  background: rgba(#000a25, 0.5);
  text-align: center;
  font-size: 26px;
  line-height: 34px;
  font-weight: 900;
  color: #fff;
  border-radius: 6px;
  padding: 30px;

  @include breakpoint("sm-and-down") {
    font-size: 22px;
    line-height: 28px;
    padding: 20px;
  }

  @include breakpoint("xs-only") {
    font-size: 17px;
    line-height: 24px;
    padding: 12px;
  }
}

.alert-action {
  margin-top: 30px;
  display: flex;
  align-items: center;
}
</style>
